import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
// logic
import { userIsAuthenticatedRedir } from 'components/auth/hoc';
import { push } from 'connected-react-router';
import routes from 'utils/routes';
// state
import { useDispatch } from 'react-redux';
import { actions as ordersActions } from 'state/orders';
// styles
import styled from 'styled-components';
// components
import FeasibilityContextProvider from 'hooks/useFeasibility';
import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';
import NewShipmentButton from 'components/orders/newShipmentButton';
import OrdersModals from 'components/orders/ordersModals';
import OrdersTabs from 'components/orders/ordersTabs';
import OrdersRoutes from 'components/orders/ordersRoutes';
import SearchResultsSummary from 'components/orders/searchResultsSummary';

const OrdersPage = userIsAuthenticatedRedir(
  ({ className, history, location }) => {
    const dispatch = useDispatch();

    const handleBack = useCallback(() => {
      dispatch(ordersActions.resetData());
      dispatch(push(routes.orders.default));
    }, [dispatch]);

    const isSearchPage = location.pathname === routes.orders.search;

    return (
      <FeasibilityContextProvider>
        <AuthenticatedUserView handleBack={handleBack}>
          <section role="main" className={className}>
            {!isSearchPage && <OrdersTabs location={location} />}
            {isSearchPage && <SearchResultsSummary />}
            <OrdersRoutes history={history} />
            <NewShipmentButton />
          </section>
          <OrdersModals />
        </AuthenticatedUserView>
      </FeasibilityContextProvider>
    );
  }
);

OrdersPage.propTypes = {
  className: PropTypes.string,
  history: PropTypes.any.isRequired,
  location: PropTypes.any.isRequired,
};

export default styled(OrdersPage)`
  flex-grow: 1;
  height: 100%;
  width: 100%;
  display: flex;
  overflow: auto;
  flex-direction: column;
  background: var(--grey100-opacity50);
`;
